import { Checkin } from '../../models/checkin/checkin'
import { History } from '../../models/checkin/history'
export default {
  checkinList: state => state.checkinList,
  // checkinListItems: state => state.checkinListItems,
  checkinListItems: state => {
    let checkin_arr = state.checkinListItems;
    let result = [];
    let inservice_arr = [];
    for (let i = 0; i < checkin_arr.length; i++) {
      if (checkin_arr[i].check_out) {
        if (checkin_arr[i].check_out.status == 'pending') {
          result.push(new Checkin(checkin_arr[i]));
        } else {
          inservice_arr.push(new Checkin(checkin_arr[i]));
        }
      }
    }
    for (let i = 0; i < inservice_arr.length; i++) {
      result.push(inservice_arr[i]);
    }
    return result;
  },
  promotionList: state => state.promotionList,
  checkoutHistory: state => state.checkoutHistory,
  // checkoutHistoryItems: state => state.checkoutHistoryItems,
  checkoutHistoryItems: state => {
    let temp = [];
    for (let i = 0; i < state.checkoutHistoryItems.length; i++) {
      temp.push(new History(state.checkoutHistoryItems[i]));
    }
    return temp;
  },
  historySummary: state => state.historySummary,
  checkoutInfo: state => state.checkoutInfo,
  checkoutData: state => state.checkoutData,
  staffList: state => state.staffList,
  staffData: state => state.staffData,
  checkinData: state => state.checkinData,
  checkinInfo: state => state.checkinInfo,
  lastCheckinRecord: state => state.lastCheckinRecord,
}
